import React from 'react';
import { Sidebar, SidebarContent } from '@/Components/shadcn';
import { cn } from '@/lib/utils';

const NavDrawer = ({ children }: React.PropsWithChildren) => {
    return (
        <Sidebar
            collapsible="none"
            className={cn('border-sidebar-border bg-sidebar text-sidebar-foreground h-full shrink-0 border-r')}
        >
            <SidebarContent className="text-muted-foreground gap-0 px-2.5 py-2.5">{children}</SidebarContent>
        </Sidebar>
    );
};

export default NavDrawer;
